import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [{
    path: '',
    redirect: '/home'
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: () =>
      import('@/views/reset-password')
  },
  {
    path: '/',
    component: () =>
      import('@/views/main'),
    name: 'Home',
    children: [{
      path: '/home',
      name: 'Home',
      component: () =>
        import('@/views/candidate')
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: () =>
        import('@/views/find-jobs')
    },
    {
      path: '/chat',
      name: 'Chat',
      component: () =>
        import('@/views/candidate-chat')
    },
    {
      path: '/contact-us',
      name: 'contact',
      component: () =>
        import('@/views/contact')
    },
    {
      path: '/about-us',
      name: 'about-us',
      component: () =>
        import('@/views/about-us')
    },

    {
      path: '/privacy-policy/T&C',
      name: 'Privacy Policy/T&C',
      component: () =>
        import('@/views/termcondition')
    },
    {
      path: '/job/:id',
      name: 'CandidateDetails',
      component: () =>
        import('@/views/job-details')
    },
    {
      path: '/company/:id',
      name: 'CandidateDetails',
      component: () =>
        import('@/views/company-details')
    },
    {
      path: '/company/:id',
      name: 'CompanyDetails',
      component: () =>
        import('@/views/company-details')
    },
    {
      path: '/MTQPlus/:id',
      name: 'MTQPlus',
      component: () =>
        import('@/views/mtq')
    },




    {
      path: '/thank-you',
      name: 'Thanku',
      component: () =>
        import('@/views/thanku')
    },
    {
      path: '/my-calendar',
      name: 'My Calendar',
      component: () =>
        import('@/views/Calendar/calendar')
    },

    {
      path: '/endorsement/:token',
      name: 'Endorsement',
      component: () =>
        import('@/views/endorsement')
    },
    ],
  },
  {
    path: '/',
    component: () =>
      import('@/views/main'),
    name: 'Home',
    meta: {
      requiresAuth: true
    },
    children: [{
      path: '/profile',
      name: 'Profile',
      component: () =>
        import('@/views/profile')
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () =>
        import('@/views/dashboard')
    },

    ]
  },

  ]
})

router.beforeEach((to, from, next) => {
  document.title = `${process.env.APP_TITLE} :: ${to.name}`
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('candidate_token') || localStorage.getItem('candidate_token') == null) {
      next('/home')
    } else {
      next()
    }
  }

  if (localStorage.getItem('candidate_token') != null) {
    if (to.matched.some(record => !record.meta.requiresAuth)) {
      if (to.fullPath == '/home') {
        next()
      }
    }
    next()
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js